import request from '@/util/request';
export const getList = (params, options) =>
request.get('/api/v4ward/invoice/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/invoice/detail', Object.assign({}, options, { params }))
//获取系统字典
export const getDict = (code, options) =>
  request.get('/api/blade-system/dict/dictionary?code=' + code, Object.assign({}, options, {}));
//开票
export const directInvoicing = (data) =>
  request.post('/api/v4ward/invoice/directInvoicing',data);
//冲红
export const issueRed = (data) =>
  request.post('/api/v4ward/invoice/issueRed',data);

